import { render, staticRenderFns } from "./KvmCatalogPicker.vue?vue&type=template&id=0e2a31e4&scoped=true&"
import script from "./KvmCatalogPicker.vue?vue&type=script&lang=js&"
export * from "./KvmCatalogPicker.vue?vue&type=script&lang=js&"
import style0 from "./KvmCatalogPicker.vue?vue&type=style&index=0&id=0e2a31e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a31e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2a31e4')) {
      api.createRecord('0e2a31e4', component.options)
    } else {
      api.reload('0e2a31e4', component.options)
    }
    module.hot.accept("./KvmCatalogPicker.vue?vue&type=template&id=0e2a31e4&scoped=true&", function () {
      api.rerender('0e2a31e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmCatalogPicker.vue"
export default component.exports